import { Component, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NlogService } from './services/nlog.service';

@Component({
    selector: 'nlog-component',
    templateUrl: './nlog.component.html',
    styleUrls: ['./nlog.component.css'],
})
export class NlogComponent implements AfterViewInit {
    resultsLength = 0;
    public dataSource!: any[];

    constructor(private nlogService: NlogService, private cdRef: ChangeDetectorRef) {}

    ngAfterViewInit() {
        this.nlogService.GetRecentlyByFilter(0, 10).subscribe((result: any) => {
            if (result.success) {
                console.log(result.data);
                this.resultsLength = result.data.length;
                this.dataSource = result.data;
                this.cdRef.detectChanges();
            }
        });
    }

    public searchLogs(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
    }
}
